import { Button, Head, Link, Typography } from "zudoku/components";

export const FrontPage = () => {
    return (
        <section>
            <Head>
                <title>Home</title>
            </Head>
            <div className="grid lg:gap-12 pb-8 lg:py-16 lg:grid-cols-12 gap-10">
                <div className="mr-auto lg:col-span-8 col-span-full mt-10 lg:mt-0">
                    <h1 className="mb-10 text-4xl font-extrabold tracking-tight leading-none md:text-5xl xl:text-6xl">
                        UtilityCloud Developer Portal
                    </h1>
                    <Typography className="max-w-full">
                        <p>
                            UtilityCloud is a billing and customer information system for
                            energy retailers, covering electricity, district heating, EV
                            charging, and more. This developer portal gives you everything
                            you need to integrate with UtilityCloud through our REST API.
                        </p>
                        <p>The API covers the full range of business operations:
                        </p>
                        <ul>
                            <li>Customer and contract management</li>
                            <li>Products/tariffs, and price management</li>
                            <li>Invoicing, invoice lines, and PDF retrieval</li>
                            <li>Metering points and meter values</li>
                            <li>Offers and digital signing workflows</li>
                            <li>Event subscriptions</li>
                            <li>And more ...</li>
                        </ul>
                        <p>
                            Whether you are building an integration to one of your systems, an analytics
                            solution for business insights, a self-service ordering
                            solution or a data synchronization pipeline, the common
                            workflows and API reference will guide you through the process.
                        </p>
                        <p>
                            New to the API? The Getting Started guide walks you through authentication,
                            access rights, and your first request. For a full overview of the UtilityCloud platform, visit{" "}
                            <a href="https://www.utilitycloud.tech/" target="_blank" rel="noopener noreferrer"> utilitycloud.tech
                            </a>
                        </p>
                    </Typography>
                    <div className="flex gap-4 items-center mt-6">
                        <Button variant="outline" size="xl" asChild>
                            <a href="/apis/m2m" rel="noopener noreferrer">
                                See the API Reference
                            </a>
                        </Button>
                        <span className="font-semibold">or</span>
                        <Button size="xl" asChild>
                            <Link to="/getting-started">Get started</Link>
                        </Button>
                    </div>
                </div>
                <img
                    src="/cycle.jpg"
                    className="max-w-[330px] w-full hidden lg:mt-0 lg:col-span-4 lg:flex rounded-3xl drop-shadow-lg dark:drop-shadow-none"
                    alt="UC APIs"
                />
            </div>
        </section>
    );
};
